<script lang="ts" setup>
import { inject } from 'vue';

import type { Ref } from 'vue';

const skyboxPath = inject('skyBoxPath') as Ref<string>;
</script>

<template>
  <div class="flex flex-row mb-1 items-center">
    <label for="skybox-path" class="text-xs mr-2">Folder Path</label>
    <input id="skybox-path" v-model="skyboxPath" type="text" class="border p-1 text-xs flex-grow">
  </div>
</template>
